import { useEffect, useState } from "react";
import ConversationCompletedService from "../services/ConversationCompletedService";

const POLL_INTERVAL_MS = 5000;

export default function useBulkRefreshJobs(enabled) {
    const [jobs, setJobs] = useState([]);

    useEffect(() => {
        if (!enabled) return undefined;
        let cancelled = false;
        let timer = null;

        const poll = async () => {
            if (!document.hidden) {
                const [response, error] = await ConversationCompletedService.getBulkRefreshJobs();
                if (cancelled) return;
                if (!error && response) setJobs(response.jobs || []);
            }
            if (!cancelled) timer = setTimeout(poll, POLL_INTERVAL_MS);
        };

        poll();
        return () => {
            cancelled = true;
            clearTimeout(timer);
        };
    }, [enabled]);

    const running = jobs.filter((job) => !job.finished && !job.stalled);
    const summary = running.reduce(
        (total, job) => ({
            total: total.total + job.total,
            remaining: total.remaining + job.remaining,
            done: total.done + job.done,
            failed: total.failed + job.failed,
        }),
        { total: 0, remaining: 0, done: 0, failed: 0 }
    );

    return { jobs, running, summary, isRunning: running.length > 0 };
}
